import React from 'react'
import MaterialSymbol from '../material-symbol'

const KeyboardArrowRight = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="keyboard_arrow_right" {...props} />
))

KeyboardArrowRight.displayName = 'KeyboardArrowRight'

export default KeyboardArrowRight
